import React, { useEffect, useState } from "react";
import useUtils from "hooks/useUtils";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import earnedPointsNotFoundGif from "assets/images/gifs/Earnedpoint-not-found.gif";
import { useSelector } from "react-redux";
import Pagination from "components/pagination";
import useAmbassador from "containers/ambassador/useHooks";

const EarnedPoints: React.FC = () => {
  const { getDateTime } = useUtils();
  const { getEarnedPoints } = useAmbassador();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<any[]>([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    totalElements: 0,
  });

  const loadEarnedPoints = (page = 0, size = 10) => {
    const queryParams = {
      page,
      size,
    };
    getEarnedPoints(setData, queryParams, setFilters);
  };

  const handlePageChange = ({
    selected,
    limit,
  }: {
    selected: number;
    limit: number;
  }) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: selected,
      size: limit,
    }));
    loadEarnedPoints(selected, limit);
  };

  useEffect(() => {
    loadEarnedPoints();
  }, []);

  // Mark initial load as complete when loading finishes
  useEffect(() => {
    if (!hasFetched && !isLoading) {
      setHasFetched(true);
    }
  }, [isLoading, hasFetched]);

  return (
    <div className="min-h-[50vh]">
      {data && data.length > 0 ? (
        <>
          {data.map((item, index) => (
            <div
              key={index}
              className="flex justify-between items-start p-5 rounded-lg shadow-card bg-white mb-4"
            >
              <div className="flex items-start gap-3">
                {item.icon && (
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg text-lg">
                    {item.icon}
                  </div>
                )}
                <div>
                  <p className="font-semibold text-black capitalize text-sm">
                    {item.activity}
                  </p>
                  <p className="text-gray-500 text-xs mt-1">{item.effort}</p>
                  <p className="text-gray-400 text-xs mt-1">
                    {getDateTime(item.updatedAt)}
                  </p>
                </div>
              </div>
              <div className="text-teal-500 font-semibold text-sm whitespace-nowrap mt-1">
                +{item.pointsEarned} pts
              </div>
            </div>
          ))}
          {data.length > 0 && filters.totalElements > filters.size && (
            <Pagination
              count={filters.totalElements}
              page={filters.page}
              limit={filters.size}
              onPageChange={handlePageChange}
              activeBgColor={"#37588A"}
              activeTextColor={"#ffffff"}
            />
          )}
        </>
      ) : (
        <CustomMessageDisplay
          show={hasFetched && !isLoading && data.length === 0}
          title="No Points History"
          slogan="You haven't earned any points yet."
          image={earnedPointsNotFoundGif}
          imageAlt="No history found"
          className="py-12"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      )}
    </div>
  );
};

export default EarnedPoints;
